/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_account_forgot_password_title = /** @type {(inputs: {}) => string} */ () => {
	return `Zapomněli jste heslo?`
};

const da_account_forgot_password_title = /** @type {(inputs: {}) => string} */ () => {
	return `Glemt adgangskode?`
};

const de_account_forgot_password_title = /** @type {(inputs: {}) => string} */ () => {
	return `Passwort vergessen?`
};

const en_account_forgot_password_title = /** @type {(inputs: {}) => string} */ () => {
	return `Forgot Your Password?`
};

const es_account_forgot_password_title = /** @type {(inputs: {}) => string} */ () => {
	return `¿Olvidaste tu contraseña?`
};

const fr_account_forgot_password_title = /** @type {(inputs: {}) => string} */ () => {
	return `Mot de passe oublié ?`
};

const hu_account_forgot_password_title = /** @type {(inputs: {}) => string} */ () => {
	return `Elfelejtett jelszó?`
};

const it_account_forgot_password_title = /** @type {(inputs: {}) => string} */ () => {
	return `Password dimenticata?`
};

const nl_account_forgot_password_title = /** @type {(inputs: {}) => string} */ () => {
	return `Wachtwoord vergeten?`
};

const pl_account_forgot_password_title = /** @type {(inputs: {}) => string} */ () => {
	return `Zapomniałeś hasła?`
};

const pt_account_forgot_password_title = /** @type {(inputs: {}) => string} */ () => {
	return `Esqueceu a senha?`
};

const sv_account_forgot_password_title = /** @type {(inputs: {}) => string} */ () => {
	return `Glömt lösenord?`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const account_forgot_password_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.account_forgot_password_title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("account_forgot_password_title", locale)
	if (locale === "cs") return cs_account_forgot_password_title(inputs)
	if (locale === "da") return da_account_forgot_password_title(inputs)
	if (locale === "de") return de_account_forgot_password_title(inputs)
	if (locale === "en") return en_account_forgot_password_title(inputs)
	if (locale === "es") return es_account_forgot_password_title(inputs)
	if (locale === "fr") return fr_account_forgot_password_title(inputs)
	if (locale === "hu") return hu_account_forgot_password_title(inputs)
	if (locale === "it") return it_account_forgot_password_title(inputs)
	if (locale === "nl") return nl_account_forgot_password_title(inputs)
	if (locale === "pl") return pl_account_forgot_password_title(inputs)
	if (locale === "pt") return pt_account_forgot_password_title(inputs)
	return sv_account_forgot_password_title(inputs)
};
export { account_forgot_password_title as "account.forgot_password_title" }